import {useMemo} from "react";
import MetricDashCard from "../../../../../components/dash-card/metric-dash-card.jsx";
import DashCard from "../../../../../components/dash-card/dash-card.jsx";
import SentryEchart from "../../../../../components/echarts/sentry-echart.jsx";
import {
    DASHBOARD_LAST_POINT_SERIES_STYLE,
    DASHBOARD_LINE_CHART_GRID,
    DASHBOARD_LINE_CHART_TOOLTIP,
    DASHBOARD_LINE_CHART_X_AXIS,
    DASHBOARD_LINE_CHART_Y_AXIS,
    DASHBOARD_LINE_SERIES_STYLE,
} from "../../utils/line-chart-styles.js";

export default function AlarmsCard({ monitoring }) {
    function formatAverageResponse(milliseconds) {
        const duration = Math.abs(Number(milliseconds));

        if (!Number.isFinite(duration)) return "0 segundos";

        if (duration >= 3600000) {
            const hours = Math.round(duration / 3600000);
            return `${hours}h`;
        }

        if (duration >= 60000) {
            const minutes = Math.round(duration / 60000);
            return `${minutes}m`;
        }

        const seconds = Math.round(duration / 1000);
        return `${seconds}s`;
    }

    const timeline = monitoring?.timeline;
    const averageResponse = formatAverageResponse(monitoring?.averageResponseMillis);

    const areaChartOption = useMemo(() => {
        const areaChartData = Array.isArray(timeline)
            ? timeline.map(item => ({
                label: `${String(item.hour).padStart(2, "0")}h`,
                value: item.qty ?? 0,
            }))
            : [];

        const lastPoint = areaChartData.at(-1);

        return {
            grid: DASHBOARD_LINE_CHART_GRID,
            tooltip: {
                ...DASHBOARD_LINE_CHART_TOOLTIP,
                formatter: (params) => {
                    const [point] = params;
                    return `${point.axisValue}<br/>${point.marker} Alarmes: <b>${point.value}</b>`;
                },
            },
            xAxis: {
                ...DASHBOARD_LINE_CHART_X_AXIS,
                data: areaChartData.map(item => item.label),
            },
            yAxis: DASHBOARD_LINE_CHART_Y_AXIS,
            series: [
                {
                    ...DASHBOARD_LINE_SERIES_STYLE,
                    name: "Alarmes",
                    data: areaChartData.map(item => item.value),
                },
                {
                    ...DASHBOARD_LAST_POINT_SERIES_STYLE,
                    name: "Último ponto",
                    data: lastPoint ? [[lastPoint.label, lastPoint.value]] : [],
                },
            ],
        };
    }, [timeline]);

    return (
        <article className="col-span-15 min-h-0 min-w-0 h-full w-full grid grid-rows-[minmax(72px,auto)_minmax(0,1fr)] gap-3">
            <div className="grid grid-cols-[113fr_94fr_94fr_210fr] gap-3 min-h-0 min-w-0">
                <MetricDashCard
                    counterCard
                    title="Alarmes"
                    value={monitoring?.alarmsTotal ?? 0}
                    width="auto"
                    height="auto"
                    dashClassName="min-h-[72px] min-w-0 px-3!"
                />

                <MetricDashCard
                    title="Sentry"
                    value={monitoring?.sentryAlarms ?? 0}
                    width="auto"
                    height="auto"
                    dashClassName="min-h-[72px] min-w-0 px-3!"
                />

                <MetricDashCard
                    title="Integrações"
                    value={monitoring?.externalAlarms ?? 0}
                    width="auto"
                    height="auto"
                    dashClassName="min-h-[72px] min-w-0 px-3!"
                />

                <MetricDashCard
                    counterCard
                    title="Tempo médio de resposta"
                    value={averageResponse}
                    width="auto"
                    height="auto"
                    dashClassName="min-h-[72px] min-w-0 px-3!"
                />
            </div>

            <DashCard width="100%" height="100%" className="min-h-0 h-full p-4!">
                <SentryEchart
                    className="h-full min-h-0"
                    option={areaChartOption}
                />
            </DashCard>
        </article>
    )
}
